import { routeBase } from '@/config/router'
import { ErrorCode } from '@/errors/codes'

/**
 * URL path segment after `${routeBase}/error/` for each error code.
 */
const ERROR_ROUTE_SEGMENT_BY_CODE: Record<ErrorCode, string> = {
  [ErrorCode.Unauthorized]: '401-unauthorized',
  [ErrorCode.AuthCodeTokenExchangeFailed]: '401-auth-code-token-exchange-failed',
  [ErrorCode.KeycloakTokenSignatureInvalid]: '401-keycloak-token-signature-invalid',
  [ErrorCode.KeycloakTokenExpirationInvalid]: '401-keycloak-token-expiration-invalid',
  [ErrorCode.KeycloakJwtDecodeFailed]: '401-keycloak-jwt-decode-failed',
  [ErrorCode.UnknownErrorDuringJwtDecoding]: '401-unknown-error-during-jwt-decoding',
  [ErrorCode.KeycloakIdTokenNonceViolation]: '401-keycloak-id-token-nonce-violation',
  [ErrorCode.KeycloakIntrospectionFailed]: '401-keycloak-introspection-failed',
  [ErrorCode.XauthDataCookieTooLarge]: '401-xauth-data-cookie-too-large',
  [ErrorCode.KeycloakUserinfoTimeout]: '401-keycloak-userinfo-timeout',
  [ErrorCode.KeycloakUserinfoHttpError]: '401-keycloak-userinfo-http-error',
  [ErrorCode.KeycloakUserinfoUnknownError]: '401-keycloak-userinfo-unknown-error',
  [ErrorCode.UserinfoMissingContact]: '401-userinfo-missing-contact',
  [ErrorCode.UserinfoMissingName]: '401-userinfo-missing-name',
  [ErrorCode.UserinfoMissingGender]: '401-userinfo-missing-gender',
  [ErrorCode.UserinfoInvalidGender]: '401-userinfo-invalid-gender',
  [ErrorCode.UserinfoMissingAddress]: '401-userinfo-missing-address',
  [ErrorCode.UserinfoValidation]: '401-userinfo-validation',
  [ErrorCode.UserinfoUnknownGroup]: '401-userinfo-unknown-group',
  [ErrorCode.UserinfoUnknownRole]: '401-userinfo-unknown-role',
  [ErrorCode.XsrfTokenCookieMissing]: '401-xsrf-token-cookie-missing',
  [ErrorCode.NoCsrfHeader]: '403-no-csrf-header',
  [ErrorCode.CsrfTokenMismatch]: '403-csrf-token-mismatch',
  [ErrorCode.XauthDataCookieDecryptFailed]: '401-xauth-data-cookie-decrypt-failed',
  [ErrorCode.XauthDataCookieDecompressFailed]: '401-xauth-data-cookie-decompress-failed',
  [ErrorCode.XauthDataCookieDeserializeFailed]: '401-xauth-data-cookie-deserialize-failed',
  [ErrorCode.XauthDataCookieUnknownError]: '401-xauth-data-cookie-unknown-error',
  [ErrorCode.AccessTokenMissing]: '401-access-token-missing',
  [ErrorCode.SessionNotAuthenticated]: '401-session-not-authenticated',
  [ErrorCode.AccessTokenRefreshFailed]: '401-access-token-refresh-failed',
  [ErrorCode.PermissionDenied]: '403-permission-denied',
  [ErrorCode.ClientsByIdsNoClientsFound]: '403-clients-by-ids-no-clients-found',
  [ErrorCode.NoFragmentInAuthResponse]: '401-no-fragment-in-auth-response',
  [ErrorCode.NoCodeInAuthResponse]: '401-no-code-in-auth-response',
  [ErrorCode.NoStateInAuthResponse]: '401-no-state-in-auth-response',
  [ErrorCode.InvalidStateInAuthResponse]: '401-invalid-state-in-auth-response',
  [ErrorCode.NoSessionStateInAuthResponse]: '401-no-session-state-in-auth-response',
  [ErrorCode.NoIssInAuthResponse]: '401-no-iss-in-auth-response',
  [ErrorCode.InvalidIssInAuthResponse]: '401-invalid-iss-in-auth-response',
  [ErrorCode.NoNonceInStorage]: '401-no-nonce-in-storage',
  [ErrorCode.NotFound]: '404-not-found',
  [ErrorCode.KeycloakUnavailable]: '503-keycloak-unavailable',
}

/** Full router path for the error view for the given code. */
export function errorPathForCode(code: ErrorCode): string {
  return `${routeBase}/error/${ERROR_ROUTE_SEGMENT_BY_CODE[code]}`
}
